import { createPortal } from "react-dom";

import '../Styles/ProjectShowcase.css';

const AddLink = ({
    addLink = () => { },
    show,
    setShow,
    toaster = () => { }
}) => {
    const ADMIN_PASSWORD = process.env.ADMIN_PASSWORD;

    const onSubmit = (event) => {
        event.preventDefault();

        const title = event.target.title.value;
        const link = event.target.link.value;
        const password = event.target.password.value;

        if (password === ADMIN_PASSWORD) {
            addLink({
                title,
                link
            });
        } else {
            toaster({message: 'Incorrect Password!', error: true});
        }
    }

    return createPortal(
        <div className={`modal project-showcase ${show ? 'modal-show' : ''}`}>
            <div
                className='modal-backdrop'
                onClick={() => setShow(false)}
            ></div>
            <form
                className='add-link-form contact-form project-large but-small'
                onSubmit={onSubmit}
            >
                <h1 className='pl-title'>
                    Add New Link
                </h1>
                <div className='contact-field'>
                    <label
                        htmlFor='title'
                        className='contact-label'
                    >
                        Enter Link Title:
                    </label>
                    <input
                        id='title'
                        name='title'
                        placeholder='Title'
                        required
                        className='contact-input'
                    />
                </div>
                <div className='contact-field'>
                    <label
                        htmlFor='link'
                        className='contact-label'
                    >
                        Enter Link:
                    </label>
                    <input
                        id='link'
                        name='link'
                        placeholder='Link'
                        required
                        className='contact-input'
                    />
                </div>
                <div className='contact-field'>
                    <label
                        htmlFor='password'
                        className='contact-label'
                    >
                        Enter Password:
                    </label>
                    <input
                        id='password'
                        type='password'
                        name='password'
                        placeholder='Password'
                        required
                        className='contact-input'
                    />
                </div>
                <button
                    className={'contact-btn btn'}
                    type='submit'
                >
                    Submit{' '}
                    <span className='fas send-icon'>
                        {'\uf1d8'}
                    </span>
                </button>
            </form>
        </div>,
        document.getElementById('modal')
    )
};

export default AddLink;